import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import hotelImg from "../assests/images/hotel-bg.jpg";
import Hero from "../components/Hero";
import { useLocation } from "react-router-dom";

import {
    FaHeart,
    FaRegHeart,
    FaMapMarkerAlt,
    FaStar,
    FaStarHalfAlt,
    FaRegStar,
    FaSearch,
    FaMoneyBillWave,
    FaMapMarkedAlt,
    FaUndo
} from "react-icons/fa";



export default function HotelList({
    limit,
    showViewAllButton = false,
    showSidebar = true,
    showBanner = false,
    showHeading = false   // ✅ ADD THIS
}) {

    const [hotels, setHotels] = useState([]);
    const [loading, setLoading] = useState(true);

    const location = useLocation();

    // Wishlist
    const [wishlist, setWishlist] = useState([]);

    // Filters
    const [search, setSearch] = useState("");
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(5000);
    const [rating, setRating] = useState(0);

    const [destinations, setDestinations] = useState([]);
    const [selectedDestinations, setSelectedDestinations] = useState([]);

    const navigate = useNavigate();

    // ✅ LOAD WISHLIST FROM LOCALSTORAGE
    useEffect(() => {
        const storedWishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
        setWishlist(storedWishlist);
    }, []);

    // ✅ UPDATE WISHLIST
    const updateWishlist = (updated) => {
        setWishlist(updated);
        localStorage.setItem("wishlist", JSON.stringify(updated));
    };

    // ✅ TOGGLE WISHLIST
    const toggleWishlist = (hotel) => {
        const exists = wishlist.find(item => item.id === hotel.id);

        let updated;
        if (exists) {
            updated = wishlist.filter(item => item.id !== hotel.id);
        } else {
            updated = [...wishlist, hotel];
        }

        updateWishlist(updated);
    };

    // ✅ CHECK IF IN WISHLIST
    const isWishlisted = (id) => {
        return wishlist.some(item => item.id === id);
    };

    // Fetch Destinations
    const fetchDestinations = async () => {
        try {
            const res = await axios.get("https://jumeiradiscounthotels.com/api/destinations");
            setDestinations(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchDestinations();
    }, []);

    const handleDestinationChange = (dest) => {
        setSelectedDestinations((prev) =>
            prev.some(d => d.id === dest.id)
                ? prev.filter((d) => d.id !== dest.id)
                : [...prev, dest]
        );
    };

    // Debounce search
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => clearTimeout(handler);
    }, [search]);

    // Fetch Hotels
    const fetchHotels = async () => {
        setLoading(true);
        try {
            const res = await axios.get("https://jumeiradiscounthotels.com/api/hotels", {
                params: {
                    search: debouncedSearch,
                    destinations: selectedDestinations.map(d => d.id),
                    minPrice,
                    maxPrice,
                    rating,
                },
            });

            setHotels(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchHotels();
    }, [debouncedSearch, minPrice, maxPrice, rating, selectedDestinations]);

    // Stars
    const renderStars = (ratingValue) => {
        return Array.from({ length: 5 }, (_, i) => {
            if (i < Math.floor(ratingValue)) return <FaStar key={i} />;
            if (i === Math.floor(ratingValue) && ratingValue % 1 >= 0.5)
                return <FaStarHalfAlt key={i} />;
            return <FaRegStar key={i} />;
        });
    };

    // Reset Filters
    const isFilterChanged =
        search !== "" ||
        minPrice !== 0 ||
        maxPrice !== 5000 ||
        rating !== 0 ||
        selectedDestinations.length > 0;

    const resetFilters = () => {
        setSearch("");
        setMinPrice(0);
        setMaxPrice(5000);
        setRating(0);
        setSelectedDestinations([]);
    };



    return (





        <div className="w-full">
            {showBanner && (
                <Hero
                    variant="inner"
                    title="All Hotels"
                    subtitle="Explore the best stays and experiences"
                    backgroundImage={hotelImg}
                />
            )}
            <div
                className={`mx-auto ${showBanner ? "max-w-screen-2xl" : "max-w-7xl"
                    } px-4 lg:px-8 py-10 sm:py-12 md:py-16 lg:py-20`}
            >
                {/* Heading */}

                {showHeading && (
                    <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">

                        <div>
                            <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-100 text-[#0F172A] text-sm font-semibold mb-4">
                                Hotel Collection
                            </span>

                            <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
                                Find Your Perfect Stay
                            </h2>

                            <p className="text-slate-500 mt-3 max-w-2xl">
                                Browse luxury hotels, resorts and budget-friendly stays
                                across Dubai's most popular destinations.
                            </p>
                        </div>

                        <button
                            onClick={() => navigate("/hotels")}
                            className="hidden sm:flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F] hover:bg-gradient-to-br text-white rounded-xl  transition"
                        >
                            View All Hotels →
                        </button>

                    </div>
                )}

                {/* Layout */}
                <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
                    {/* Sidebar */}
                    {showSidebar && (
                        <div className="w-full lg:w-1/4">
                            <div className="lg:sticky lg:top-28">

                                <div className="relative overflow-hidden bg-white rounded-3xl border border-slate-200 shadow-[0_12px_40px_rgba(15,23,42,0.10)]">

                                    {/* Top Accent */}
                                    <div className="h-1.5 bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F]"></div>

                                    <div className="p-5 sm:p-6">

                                        {/* Header */}
                                        <div className="flex items-center justify-between gap-3 pb-5 border-b border-slate-100">

                                            <div>
                                                <div className="flex items-center gap-2 mb-1">
                                                    <span className="w-7 h-7 rounded-lg bg-[#002B45] text-white flex items-center justify-center">
                                                        <FaSearch className="text-xs" />
                                                    </span>

                                                    <h3 className="text-lg sm:text-xl font-extrabold text-[#002B45]">
                                                        Find Your Hotel
                                                    </h3>
                                                </div>

                                                <p className="text-xs text-slate-400 ml-9">
                                                    Refine your search
                                                </p>
                                            </div>

                                            {isFilterChanged && (
                                                <button
                                                    onClick={resetFilters}
                                                    className="flex items-center gap-1.5 px-3 py-2 rounded-xl bg-slate-100 hover:bg-red-50 text-slate-600 hover:text-red-500 text-xs font-semibold transition-all duration-300"
                                                >
                                                    <FaUndo className="text-[10px]" />
                                                    Reset
                                                </button>
                                            )}
                                        </div>

                                        {/* Search */}
                                        <div className="pt-5">

                                            <label className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-500">
                                                <FaSearch className="text-[#174B5F]" />
                                                Search Hotels
                                            </label>

                                            <div className="relative mt-3">

                                                <input
                                                    type="text"
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    placeholder="Hotel or destination..."
                                                    className="w-full pl-11 pr-4 py-3.5 rounded-2xl bg-slate-50 border border-slate-200 text-sm text-slate-800 placeholder:text-slate-400 outline-none focus:bg-white focus:border-[#174B5F] focus:ring-4 focus:ring-[#174B5F]/10 transition-all duration-300"
                                                />

                                                <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />

                                            </div>
                                        </div>

                                        {/* Price */}
                                        <div className="mt-7">

                                            <div className="flex items-center justify-between">

                                                <label className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-500">
                                                    <span className="w-7 h-7 rounded-lg bg-emerald-50 flex items-center justify-center">
                                                        <FaMoneyBillWave className="text-emerald-500 text-xs" />
                                                    </span>

                                                    Price Range
                                                </label>

                                            </div>

                                            <div className="flex gap-2 mt-3">

                                                <div className="relative flex-1">
                                                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] font-bold text-slate-400">
                                                        AED
                                                    </span>

                                                    <input
                                                        type="number"
                                                        value={minPrice}
                                                        onChange={(e) => setMinPrice(e.target.value)}
                                                        placeholder="Min"
                                                        className="w-full pl-12 pr-3 py-3 rounded-xl bg-slate-50 border border-slate-200 text-sm outline-none focus:bg-white focus:border-[#174B5F] focus:ring-4 focus:ring-[#174B5F]/10 transition-all duration-300"
                                                    />
                                                </div>

                                                <div className="flex items-center text-slate-300">
                                                    —
                                                </div>

                                                <div className="relative flex-1">
                                                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[11px] font-bold text-slate-400">
                                                        AED
                                                    </span>

                                                    <input
                                                        type="number"
                                                        value={maxPrice}
                                                        onChange={(e) => setMaxPrice(e.target.value)}
                                                        placeholder="Max"
                                                        className="w-full pl-12 pr-3 py-3 rounded-xl bg-slate-50 border border-slate-200 text-sm outline-none focus:bg-white focus:border-[#174B5F] focus:ring-4 focus:ring-[#174B5F]/10 transition-all duration-300"
                                                    />
                                                </div>

                                            </div>
                                        </div>

                                        {/* Rating */}
                                        <div className="mt-7">

                                            <label className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-500">
                                                <span className="w-7 h-7 rounded-lg bg-amber-50 flex items-center justify-center">
                                                    <FaStar className="text-amber-500 text-xs" />
                                                </span>

                                                Hotel Rating
                                            </label>

                                            <div className="relative mt-3">

                                                <select
                                                    value={rating}
                                                    onChange={(e) => setRating(e.target.value)}
                                                    className="appearance-none w-full px-4 py-3.5 pr-10 rounded-2xl bg-slate-50 border border-slate-200 text-sm font-medium text-slate-700 outline-none cursor-pointer focus:bg-white focus:border-[#174B5F] focus:ring-4 focus:ring-[#174B5F]/10 transition-all duration-300"
                                                >
                                                    <option value="0">All Ratings</option>
                                                    <option value="3">3★ & above</option>
                                                    <option value="4">4★ & above</option>
                                                    <option value="4.5">4.5★ & above</option>
                                                </select>

                                                <span className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
                                                    ▼
                                                </span>

                                            </div>
                                        </div>

                                        {/* Destinations */}
                                        <div className="mt-7">

                                            <div className="flex items-center justify-between">

                                                <label className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-500">
                                                    <span className="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center">
                                                        <FaMapMarkedAlt className="text-blue-500 text-xs" />
                                                    </span>

                                                    Destinations
                                                </label>

                                                {selectedDestinations.length > 0 && (
                                                    <span className="px-2.5 py-1 rounded-full bg-[#002B45] text-white text-[10px] font-bold">
                                                        {selectedDestinations.length} Selected
                                                    </span>
                                                )}

                                            </div>

                                            <div className="mt-3 max-h-56 overflow-y-auto pr-1 space-y-1.5 scrollbar-thin scrollbar-thumb-slate-200">

                                                {destinations.map((dest) => {

                                                    const isChecked = selectedDestinations.some(
                                                        (d) => d.id === dest.id
                                                    );

                                                    return (
                                                        <label
                                                            key={dest.id}
                                                            className={`group flex items-center justify-between gap-3 px-3.5 py-3 rounded-xl cursor-pointer border transition-all duration-200 ${isChecked
                                                                ? "bg-[#002B45] border-[#002B45] shadow-md"
                                                                : "bg-slate-50 border-transparent hover:bg-white hover:border-slate-200 hover:shadow-sm"
                                                                }`}
                                                        >

                                                            <div className="flex items-center gap-3 min-w-0">

                                                                <span
                                                                    className={`w-2 h-2 rounded-full flex-shrink-0 transition ${isChecked
                                                                        ? "bg-[#D4A83F]"
                                                                        : "bg-slate-300 group-hover:bg-[#174B5F]"
                                                                        }`}
                                                                ></span>

                                                                <span
                                                                    className={`text-sm font-medium truncate ${isChecked
                                                                        ? "text-white"
                                                                        : "text-slate-600"
                                                                        }`}
                                                                >
                                                                    {dest.name}
                                                                </span>

                                                            </div>

                                                            <input
                                                                type="checkbox"
                                                                checked={isChecked}
                                                                onChange={() =>
                                                                    handleDestinationChange(dest)
                                                                }
                                                                className="w-4 h-4 rounded accent-[#D4A83F] cursor-pointer flex-shrink-0"
                                                            />

                                                        </label>
                                                    );
                                                })}

                                            </div>
                                        </div>

                                        {/* Active Filters */}
                                        {isFilterChanged && (
                                            <div className="mt-6 pt-5 border-t border-slate-100">

                                                <div className="flex items-center gap-2 text-xs font-semibold text-slate-500">
                                                    <span className="w-2 h-2 rounded-full bg-[#D4A83F] animate-pulse"></span>
                                                    Filters are active
                                                </div>

                                                <button
                                                    onClick={resetFilters}
                                                    className="w-full mt-3 py-3 rounded-xl bg-gradient-to-r from-[#002B45] via-[#174B5F] to-[#D4A83F] text-white text-sm font-bold shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
                                                >
                                                    Clear All Filters
                                                </button>

                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Hotels */}
                    <div className={showSidebar ? "w-full lg:w-3/4" : "w-full"}>

                        {/* Top Bar */}
                        {location.pathname === "/hotels" && (
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
                                <div>
                                    <h2 className="text-3xl font-bold text-slate-900">
                                        Showing
                                        <span className="text-[#0F172A]"> {hotels.length} </span>
                                        Hotels
                                    </h2>

                                    <p className="text-slate-500 mt-1">
                                        Discover luxury stays across Dubai
                                    </p>
                                </div>
                            </div>
                        )}

                        {loading ? (
                            <div className="flex justify-center py-20">
                                <div className="animate-spin h-12 w-12 border-4 border-[#174B5F] border-t-transparent rounded-full"></div>
                            </div>
                        ) : (
                            <>
                                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 lg:gap-7">
                                    {(limit ? hotels.slice(0, limit) : hotels).map((hotel) => (
                                        <div
                                            key={hotel.id}
                                            className="
                        group
                        bg-white
                        rounded-[24px]
                        overflow-hidden
                        border border-slate-200/80
                        shadow-[0_8px_30px_rgba(15,23,42,0.06)]
                        hover:shadow-[0_20px_50px_rgba(15,23,42,0.12)]
                        hover:-translate-y-1
                        transition-all
                        duration-500
                        flex
                        flex-col
                    "
                                        >

                                            {/* ================= IMAGE ================= */}
                                            <div
                                                className="relative h-[250px] overflow-hidden cursor-pointer"
                                                onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                            >
                                                <img
                                                    src={`https://uaediscountedhotels.com/uploads/hotels/${hotel.image}`}
                                                    alt={hotel.name}
                                                    className="
                                w-full
                                h-full
                                object-cover
                                group-hover:scale-105
                                transition-transform
                                duration-700
                            "
                                                />

                                                {/* Elegant Overlay */}
                                                <div className="absolute inset-0 bg-gradient-to-t from-[#001E30]/70 via-transparent to-transparent"></div>

                                                {/* Location */}
                                                <div className="absolute top-4 left-4">
                                                    <div className="
                                flex
                                items-center
                                gap-2
                                bg-white/95
                                backdrop-blur-md
                                px-3
                                py-2
                                rounded-xl
                                shadow-lg
                            ">
                                                        <FaMapMarkerAlt className="text-[#D4A83F] text-xs" />

                                                        <span className="text-xs font-semibold text-slate-700">
                                                            {hotel.location || "Dubai"}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Wishlist */}
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleWishlist(hotel);
                                                    }}
                                                    className="
                                absolute
                                top-4
                                right-4
                                w-11
                                h-11
                                rounded-xl
                                bg-white/95
                                backdrop-blur-md
                                shadow-lg
                                flex
                                items-center
                                justify-center
                                hover:scale-110
                                transition-all
                                duration-300
                            "
                                                >
                                                    {isWishlisted(hotel.id) ? (
                                                        <FaHeart className="text-red-500" />
                                                    ) : (
                                                        <FaRegHeart className="text-slate-500" />
                                                    )}
                                                </button>

                                                {/* Bottom Image Info */}
                                                <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">

                                                    {/* Rating */}
                                                    <div className="
                                flex
                                items-center
                                gap-2
                                bg-white/95
                                backdrop-blur-md
                                px-3
                                py-2
                                rounded-xl
                                shadow-lg
                            ">
                                                        <div className="flex items-center gap-0.5 text-[#D4A83F]">
                                                            {renderStars(hotel.rating)}
                                                        </div>

                                                        <span className="text-xs font-bold text-slate-800">
                                                            {hotel.rating || "4.5"}
                                                        </span>
                                                    </div>

                                                    {/* Price */}
                                                    <div className="
                                bg-[#002B45]
                                text-white
                                rounded-xl
                                px-4
                                py-2.5
                                shadow-xl
                            ">
                                                        <p className="text-[9px] uppercase tracking-wider text-slate-300">
                                                            From
                                                        </p>

                                                        <p className="text-base font-bold">
                                                            AED {Math.round(hotel.price_per_night)}
                                                        </p>

                                                        <p className="text-[9px] text-slate-300">
                                                            per night
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>

                                            {/* ================= CONTENT ================= */}
                                            <div className="p-5 sm:p-6 flex flex-col flex-1">

                                                {/* Hotel Name */}
                                                <h3
                                                    onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                                    className="
                                text-xl
                                font-bold
                                text-[#002B45]
                                line-clamp-1
                                cursor-pointer
                                hover:text-[#174B5F]
                                transition-colors
                            "
                                                >
                                                    {hotel.name}
                                                </h3>

                                                {/* Location */}
                                                <div className="flex items-center gap-2 mt-2">
                                                    <FaMapMarkerAlt className="text-[#D4A83F] text-xs" />

                                                    <span className="text-sm text-slate-500 line-clamp-1">
                                                        {hotel.location || "Dubai, UAE"}
                                                    </span>
                                                </div>

                                                {/* Description */}
                                                <p className="
                            text-sm
                            text-slate-500
                            leading-6
                            mt-4
                            line-clamp-2
                            min-h-[48px]
                        ">
                                                    {hotel.short_description?.replace(/<[^>]*>/g, "")}
                                                </p>

                                                {/* ================= AMENITIES ================= */}
                                                <div className="
                            flex
                            flex-wrap
                            gap-2
                            mt-5
                            pt-4
                            border-t
                            border-slate-100
                        ">

                                                    <span className="
                                inline-flex
                                items-center
                                gap-1.5
                                px-2.5
                                py-1.5
                                rounded-lg
                                bg-slate-50
                                text-slate-500
                                text-[11px]
                                font-medium
                            ">
                                                        🏊 Pool
                                                    </span>

                                                    <span className="
                                inline-flex
                                items-center
                                gap-1.5
                                px-2.5
                                py-1.5
                                rounded-lg
                                bg-slate-50
                                text-slate-500
                                text-[11px]
                                font-medium
                            ">
                                                        📶 WiFi
                                                    </span>

                                                    <span className="
                                inline-flex
                                items-center
                                gap-1.5
                                px-2.5
                                py-1.5
                                rounded-lg
                                bg-slate-50
                                text-slate-500
                                text-[11px]
                                font-medium
                            ">
                                                        🍽 Restaurant
                                                    </span>

                                                </div>

                                                {/* ================= FOOTER ================= */}
                                                <div className="
                            flex
                            items-center
                            justify-between
                            gap-3
                            mt-6
                        ">

                                                    <button
                                                        onClick={() =>
                                                            navigate(`/hotels/${hotel.slug}`)
                                                        }
                                                        className="
                                    group/btn
                                    flex
                                    items-center
                                    gap-2
                                    text-sm
                                    font-bold
                                    text-[#002B45]
                                    hover:text-[#D4A83F]
                                    transition-colors
                                "
                                                    >
                                                        View Hotel

                                                        <span className="
                                    group-hover/btn:translate-x-1
                                    transition-transform
                                ">
                                                            →
                                                        </span>
                                                    </button>

                                                    <div className="
                                flex
                                items-center
                                gap-1.5
                                px-3
                                py-1.5
                                rounded-lg
                                bg-[#D4A83F]/10
                                text-[#9A7418]
                            ">
                                                        <FaStar className="text-xs" />

                                                        <span className="text-xs font-bold">
                                                            {hotel.rating || "4.5"}
                                                        </span>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                    ))}
                                </div>

                                {/* Mobile View All */}
                                {showHeading && (
                                    <div className="mt-8 sm:hidden">
                                        <button
                                            onClick={() => navigate("/hotels")}
                                            className="
                        w-full
                        bg-gradient-to-r
                        from-[#002B45]
                        via-[#174B5F]
                        to-[#D4A83F]
                        text-white
                        px-5
                        py-3.5
                        rounded-xl
                        transition-all
                        duration-300
                        font-semibold
                        shadow-lg
                        hover:shadow-xl
                    "
                                        >
                                            View All Hotels
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
}